// 予約登録リクエスト
export class RsvdtlRequest {
    constructor(
        servicePk = '',
        sessionGrpPk = '',
        issuePk1 = '',
        issuePk2 = '',
        cngMethodType = '',
        cngLanguagePk = '',
        regulationPk = '',
        regulationHistPk = '',
        cngReserveType = '',
        roomPk = '',
        counselorPk = '',
        reservationDt = '',
        regionPk = '',
        areaPk = '',
        requestDt1Start = '',
        requestDt1End = '',
        requestDt2Start = '',
        requestDt2End = '',
        requestDt3Start = '',
        requestDt3End = '',
        requestNote = ''
    ) {
        this.ServicePk = servicePk;
        this.SessionGrpPk = sessionGrpPk;
        this.IssuePk1 = issuePk1;
        this.IssuePk2 = issuePk2;
        this.CngMethodType = cngMethodType;
        this.CngLanguagePk = cngLanguagePk;
        this.RegulationPk = regulationPk;
        this.RegulationHistPk = regulationHistPk;
        this.CngReserveType = cngReserveType;
        this.RoomPk = roomPk;
        this.CounselorPk = counselorPk;
        this.ReservationDt = reservationDt;
        this.RegionPk = regionPk;
        this.AreaPk = areaPk;
        this.RequestDt1Start = requestDt1Start;
        this.RequestDt1End = requestDt1End;
        this.RequestDt2Start = requestDt2Start;
        this.RequestDt2End = requestDt2End;
        this.RequestDt3Start = requestDt3Start;
        this.RequestDt3End = requestDt3End;
        this.RequestNote = requestNote;
    }
    setValue(value) {
        this.CngMethodType = value;
    }
}

// ページ条件
class PageCond {
    constructor(rowPosition = 0, rowAmount = 0, rowCount = true) {
        this.RowPosition = rowPosition;
        this.RowAmount = rowAmount;
        this.RowCount = rowCount;
    }
}

// 予約一覧リクエスト
export class ReserveListRequest {
    constructor(lang = '', pageCond = new PageCond()) {
        this.Lang = lang;
        this.PageCond = pageCond;
    }
}

// 予約詳細取得リクエスト
export class ReserveDetailRequest {
    constructor(lang = '', reservationPk = '') {
        this.Lang = lang;
        this.ReservationPk = reservationPk;
    }
}

// 予約更新リクエスト
export class ReserveUpdateRequest {
    constructor(reservationPk = '', rsvdtlRequest = new RsvdtlRequest()) {
        this.ReservationPk = reservationPk;
        this.CngReserveType = rsvdtlRequest.CngMethodType;
        this.RoomPk = rsvdtlRequest.RoomPk;
        this.CounselorPk = rsvdtlRequest.CounselorPk;
        this.ReservationDt = rsvdtlRequest.ReservationDt;
        this.RegionPk = rsvdtlRequest.RegionPk;
        this.AreaPk = rsvdtlRequest.AreaPk;
        this.RequestDt1Start = rsvdtlRequest.RequestDt1Start;
        this.RequestDt1End = rsvdtlRequest.RequestDt1End;
        this.RequestDt2Start = rsvdtlRequest.RequestDt2Start;
        this.RequestDt2End = rsvdtlRequest.RequestDt2End;
        this.RequestDt3Start = rsvdtlRequest.RequestDt3Start;
        this.RequestDt3End = rsvdtlRequest.RequestDt3End;
        this.RequestNote = rsvdtlRequest.RequestNote;
    }
}

// 予約一覧レスポンス
export class RsvlstResponce {
    constructor(ReservationPk, ReservationNo, ReservationStatus, ReservationDt, CngMethodType) {
        this.ReservationPk = ReservationPk;
        this.ReservationNo = ReservationNo;
        this.ReservationStatus = ReservationStatus;
        this.ReservationDt = ReservationDt;
        this.CngMethodType = CngMethodType;
    }
}

// 予約詳細レスポンス
export class RsvdtlResponce {
    constructor(
        ReservationNo,
        ReservationStatus,
        AllowCancel,
        AllowChange,
        InterviewStatus,
        QuestionStatus,
        ServicePk,
        ServiceNm,
        SessionGrpPk,
        IssuePk1,
        IssueNm1,
        IssuePk2,
        IssueNm2,
        CngLanguagePk,
        CngLanguageNm,
        CngMethodType,
        CngReserveType,
        ReservationDt,
        OnlineUrl,
        ServiceTelMet,
        ServiceTelNum,
        RoomPk,
        RoomNm,
        CounselorPk,
        CounselorNm,
        RegionPk,
        RegionNm,
        AreaPk,
        AreaNm,
        RequestDt1Start,
        RequestDt1End,
        RequestDt2Start,
        RequestDt2End,
        RequestDt3Start,
        RequestDt3End,
        RequestNote,
        PaymentUrl,
        PaymentOrderId,
        PaymentStatus,
        PaymentExpireDt,
        CanselOnTheDayFlag,
        PaymentRefundStatus
    ) {
        this.ReservationNo = ReservationNo;
        this.ReservationStatus = ReservationStatus;
        this.AllowCancel = AllowCancel;
        this.AllowChange = AllowChange;
        this.InterviewStatus = InterviewStatus;
        this.QuestionStatus = QuestionStatus;
        this.ServicePk = ServicePk;
        this.ServiceNm = ServiceNm;
        this.SessionGrpPk = SessionGrpPk;
        this.IssuePk1 = IssuePk1;
        this.IssueNm1 = IssueNm1;
        this.IssuePk2 = IssuePk2;
        this.IssueNm2 = IssueNm2;
        this.CngLanguagePk = CngLanguagePk;
        this.CngLanguageNm = CngLanguageNm;
        this.CngMethodType = CngMethodType;
        this.CngReserveType = CngReserveType;
        this.ReservationDt = ReservationDt;
        this.OnlineUrl = OnlineUrl;
        this.ServiceTelMet = ServiceTelMet;
        this.ServiceTelNum = ServiceTelNum;
        this.RoomPk = RoomPk;
        this.RoomNm = RoomNm;
        this.CounselorPk = CounselorPk;
        this.CounselorNm = CounselorNm;
        this.RegionPk = RegionPk;
        this.RegionNm = RegionNm;
        this.AreaPk = AreaPk;
        this.AreaNm = AreaNm;
        this.RequestDt1Start = RequestDt1Start;
        this.RequestDt1End = RequestDt1End;
        this.RequestDt2Start = RequestDt2Start;
        this.RequestDt2End = RequestDt2End;
        this.RequestDt3Start = RequestDt3Start;
        this.RequestDt3End = RequestDt3End;
        this.RequestNote = RequestNote;
        this.PaymentUrl = PaymentUrl;
        this.PaymentOrderId = PaymentOrderId;
        this.PaymentStatus = PaymentStatus;
        this.PaymentExpireDt = PaymentExpireDt;
        this.CanselOnTheDayFlag = CanselOnTheDayFlag;
        this.PaymentRefundStatus = PaymentRefundStatus;
    }
}
